import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../common/TopImage";
import MemberTableRow from "./MemberTableRow";
import TablePagination from "../../../TeacherAdmin/pagination/TablePagination";
import { useGetAllMembers } from "../../../../../hooks/organization/members/useGetAllMembers";
import { useDeleteMember } from "../../../../../hooks/organization/members/useDeleteMember";
import { useDisableMember } from "../../../../../hooks/organization/members/useDisableMember";
import TableSkeleton from "../../../common/TableSkeleton";
import TableError from "../../../common/TableError";
import { ITEMS_PER_PAGE } from "../../../../../constant/constant";

const Member = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const { members, meta, loading, error, getAllMembers } = useGetAllMembers();

  const {
    deleteMember,
    loading: deleteLoading,
    error: deleteError,
    success: deleteSuccess,
    resetState: resetDeleteState,
  } = useDeleteMember();

  const {
    toggleMemberStatus,
    loading: toggleLoading,
    error: toggleError,
    success: toggleSuccess,
    statusMessage: toggleStatusMessage,
    resetState: resetToggleState,
  } = useDisableMember();

  useEffect(() => {
    getAllMembers({ page: currentPage });
  }, [currentPage]);

  const handleAddMember = () => {
    navigate("/school-admin/settings/members/add");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRefresh = () => {
    getAllMembers({ page: currentPage });
  };

  const handleDeleteMember = async (memberId) => {
    await deleteMember(memberId);
  };

  const handleToggleMemberStatus = async (memberId) => {
    await toggleMemberStatus(memberId);
  };

  if (loading && members === undefined) {
    return (
      <div>
        <HeaderSection handleAddMember={handleAddMember} />
        <TableSkeleton rows={ITEMS_PER_PAGE} columns={3} />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <HeaderSection handleAddMember={handleAddMember} />
        <TableError
          error={error}
          handleRefresh={handleRefresh}
          loading={loading}
        />
      </div>
    );
  }

  return (
    <div>
      <HeaderSection handleAddMember={handleAddMember} />

      {/* Members Table */}
      <div className="custom-table-container mt-3">
        <div className="custom-table-wrapper">
          <Table hover className="custom-table">
            <thead className="custom-table-head">
              <tr>
                <th className="member-col-name">Name</th>
                <th className="member-col-role">Roles</th>
                <th className="member-col-status">Status</th>
                <th className="member-col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {members && members.length > 0 ? (
                members.map((member) => (
                  <MemberTableRow
                    key={member.id}
                    member={member}
                    onDelete={handleDeleteMember}
                    deleteLoading={deleteLoading}
                    deleteError={deleteError}
                    deleteSuccess={deleteSuccess}
                    resetDeleteState={resetDeleteState}
                    onDeleteSuccess={handleRefresh}
                    onToggleStatus={handleToggleMemberStatus}
                    toggleLoading={toggleLoading}
                    toggleError={toggleError}
                    toggleSuccess={toggleSuccess}
                    toggleStatusMessage={toggleStatusMessage}
                    resetToggleState={resetToggleState}
                    onToggleSuccess={handleRefresh}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    <div className="text-center m-5">No members found.</div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <TablePagination
          totalPage={meta?.last_page || 1}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          disabled={loading}
        />
      </div>
    </div>
  );
};

/**
 * Header section component to avoid repetition
 */
const HeaderSection = ({ handleAddMember }) => (
  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div>
      <h4 className="mb-0" style={{ color: "var(--text-color)" }}>
        Members
      </h4>
    </div>
    <button className="custom-modal-primary-button" onClick={handleAddMember}>
      Add Member
    </button>
  </div>
);

export default Member;
